import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import CloseIcon from '@mui/icons-material/Close'
import styles from './dialog.styl'
import IconButton from '@mui/material/IconButton'
import cx from 'classnames'
import { iconMessageNames } from '@src/utils/icons.message'

export type DialogType = 'info' | 'error' | 'warning' | 'success'

const Line = ({ type }: { type: DialogType }) => (
  <div className={cx(styles.infoLine, styles[type])}></div>
)

export interface DialogProps {
  id?: string
  className?: string
  classNameContent?: string
  classNameHeader?: string
  type?: DialogType
  maxWidthContent?: React.ReactText
  open: boolean
  title?: React.ReactNode
  onClose: () => void
  contentText?: React.ReactNode
  footer?: React.ReactNode
  disableBackdropClick?: boolean
}
const DialogComponent: React.FC<DialogProps> = ({
  id,
  open,
  className,
  type,
  onClose,
  classNameHeader,
  classNameContent,
  maxWidthContent,
  title,
  contentText,
  children,
  disableBackdropClick,
  footer
}: React.PropsWithChildren<DialogProps>) => {
  const hasClose = typeof onClose === 'function'
  function handleClose() {
    if (hasClose) {
      onClose()
    }
  }
  return (
    <>
      <Dialog
        id={id}
        role={'modal-dialog'}
        style={{ zIndex: 1000000 }}
        maxWidth={'lg'}
        className={styles.dialog}
        classes={{
          paper: cx(className, styles.dialogRoot)
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Line type={type} />
        {title && (
          <DialogTitle
            role={'modal-dialog-header'}
            classes={{
              root: cx(classNameHeader, styles.titleRoot)
            }}
          >
            <div className={styles.dialogTitle}>
              {type && (
                <i
                  role="modal-dialog-icon"
                  className={cx(
                    'material-icons',
                    styles.iconTitle,
                    styles[type]
                  )}
                >
                  {iconMessageNames[type] || type}
                </i>
              )}
              <span role="modal-dialog-title">{title}</span>
            </div>
            {hasClose && (
              <IconButton
                role={'modal-dialog-close'}
                aria-label="close"
                className={styles.closeButton}
                onClick={handleClose}
                size="large"
              >
                <CloseIcon />
              </IconButton>
            )}
          </DialogTitle>
        )}
        <DialogContent
          role={'modal-dialog-content'}
          style={{
            maxWidth: maxWidthContent
          }}
          classes={{
            root: cx(styles.dialogContent, classNameContent, {
              [styles.withPadding]: type
            })
          }}
        >
          {contentText && (
            <DialogContentText
              role="modal-dialog-desc-text"
              classes={{
                root: styles.dialogContentText
              }}
              id="alert-dialog-description"
            >
              {contentText}
            </DialogContentText>
          )}
          {children}
        </DialogContent>
        {footer && (
          <DialogActions role="modal-dialog-footer">{footer}</DialogActions>
        )}
      </Dialog>
    </>
  )
}

export default DialogComponent
